/* Requiere de mixin.js */

var genesys = {
	data () {
		return {
			getGenesys: 'genesys/get',
            urlAPIMovimiento: "movimiento/",
			urlAPIDomicilio: "domicilio/",
			urlAPIVinculoArt: "http://genesys.aceschile.cl/api/articulo",
			urlAPIArticulo: "http://genesys.aceschile.cl/api/articulo",
			urlAPICliente: "http://genesys.aceschile.cl/api/cliente",
			urlApiAsiento: 'asiento/',
			urlApiSuscripcion: 'http://genesys.aceschile.cl/api/suscripcion',
			listTipocomp: [
				{ tipocompcod: 20, tipocompdesc: 'Orden de Pedido', sintetico:'OP', view: true},
				{ tipocompcod: 2, tipocompdesc: 'Nota de Crédito', sintetico:'NC', view: true},
				{ tipocompcod: 120, tipocompdesc: 'Reposición', sintetico:'R', view: true},
				{ tipocompcod: 40, tipocompdesc: 'Envio de Suscripción', sintetico:'ES', view: true},
				{ tipocompcod: 1, tipocompdesc: 'Boleta/Factura', sintetico:'B/F', view: false}
			],
			confComps: [
				{ tipocompcod: 2, concepto: 'ETIQUETA_ATENDIDA', estadocod: 5 },
				{ tipocompcod: 20, concepto: 'ETIQUETA_ATENDIDA', estadocod: 11 },
				{ tipocompcod: 40, concepto: 'ETIQUETA_ATENDIDA', estadocod: 5 },
				{ tipocompcod: 45, concepto: 'ETIQUETA_ATENDIDA', estadocod: 5 },
				{ tipocompcod: 100, concepto: 'ETIQUETA_ATENDIDA', estadocod: 4 },
				{ tipocompcod: 110, concepto: 'ETIQUETA_ATENDIDA', estadocod: 3 },
				{ tipocompcod: 120, concepto: 'ETIQUETA_ATENDIDA', estadocod: 5 },
				{ tipocompcod: 260, concepto: 'ETIQUETA_ATENDIDA', estadocod: 11 },
			],
			usuarios: [
				{userdoc: 1, tipdoccod: 1, nombre: 'ACES', nick:'aces'},
				{userdoc: 5, tipdoccod: 1, nombre: 'Patricia Araya', nick:'ppa'},
				{userdoc: 8, tipdoccod: 1, nombre: 'Fernando Orellana', nick:'feo'},
				{userdoc: 15, tipdoccod: 1, nombre: 'Italo Navarrete', nick:'iin'},
				{userdoc: 24, tipdoccod: 1, nombre: 'Maria Luisa Suazo', nick:'mls'},
				{userdoc: 26, tipdoccod: 7, nombre: 'Oscar Arratia', nick:'ola'},
				{userdoc: 32, tipdoccod: 1, nombre: 'Yuri Cigna', nick:'ymc'},
				{userdoc: 37, tipdoccod: 1, nombre: 'Maria Rios', nick:'mer'},
				{userdoc: 38, tipdoccod: 1, nombre: 'Ronald Caballero', nick:'rdc'},
				{userdoc: 39, tipdoccod: 1, nombre: 'Marcelo Gonzalez', nick:'mag'},
				{userdoc: 42, tipdoccod: 7, nombre: 'Angela Valdes', nick:'mav'},
				{userdoc: 48, tipdoccod: 1, nombre: 'Jonathan Neira', nick:'jin'},
				{userdoc: 53, tipdoccod: 1, nombre: 'Gustavo', nick:'gap'},

			],
			fromDateGenesys: '',
			toDateGenesys: '',
			tipocompcodSearch: 20
		}
	},
	computed: {
	},
	filters: {
	},
	methods:{
		getInfoTipoComp(tipocompcod, type = 'sintetico') {
			let info = ''
			if(type == 'sintetico') {
				let index = this.listTipocomp.map((el) => parseInt(el.tipocompcod)).indexOf(parseInt(tipocompcod))
				info = (index == -1) ? '' : this.listTipocomp[index].sintetico
			}
			return info
		},
		getConfCompByTCompConcep(tipocompcod, concepto){
			return this.confComps.filter(function (confComp) { return (confComp.tipocompcod == tipocompcod && confComp.concepto == concepto) })
		},
		getEstadoCod(tipocompcod, concepto) {
			let confComp = this.getConfCompByTCompConcep(tipocompcod, concepto)
			return (confComp.length == 1) ? confComp[0].estadocod : 0
		},
		getUsuarioByuserdoc(userdoc) {
			return this.usuarios.filter(function (usuario) { return (usuario.userdoc == userdoc) })
		},
	},
};

export default genesys;